/**
* 基础菜单 供货订单管理
*/
<template>
  <div class="contianer">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="我供货的" name="first">
      <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="">
          <el-date-picker
            v-model="formInline.Date"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-input size="small" v-model="formInline.orderCode" placeholder="输入订单编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input size="small" v-model="formInline.seller_name" placeholder="输入商家名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="formInline.orderStatus" placeholder="请选择订单状态" clearable>
            <el-option label="已取消" value="100"></el-option>
            <el-option label="待付款" value="101"></el-option>
            <el-option label="已付款" value="102"></el-option>
            <el-option label="已出库" value="104"></el-option>
            <el-option label="待收货" value="105"></el-option>
            <el-option label="已完成" value="106"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="formInline.sendStatus" placeholder="请选择发货状态" clearable>
            <el-option label="已发货" value="1"></el-option>
            <el-option label="待发货" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="formInline.pay_status" placeholder="请选择结算状态" clearable>
            <el-option label="已结算" value="1"></el-option>
            <el-option label="未结算" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="formInline.pay_type" placeholder="请选择支付类型" clearable>
            <el-option label="在线支付" value="211"></el-option>
<!--            <el-option label="线下支付" value="212"></el-option>-->
            <el-option label="挂账" value="215"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="">-->
<!--          <el-select v-model="formInline.isAgentDebtMoney" placeholder="请选择是否有欠款金额" clearable>-->
<!--            <el-option label="是" value="1"></el-option>-->
<!--            <el-option label="否" value="0"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="订单实付金额价格区间">
          <el-input size="small" v-model="formInline.minAmount" placeholder="" maxLength="7" clearable
                    style="width: 90px"></el-input>
          <span>-</span>
          <el-input size="small" v-model="formInline.maxAmount" placeholder="" maxLength="7" clearable
                    style="width: 90px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="search">查询</el-button>
          <el-button size="small" type="warning" @click="exportExcel">导出</el-button>
          <el-button size="small" type="primary" @click="getOrder">结算订单</el-button>
          <el-button size="small" type="primary" @click="getOutbound">出库</el-button>
        </el-form-item>
      </el-form>
      <!--我供货的-列表-->
      <div style="height: 550px;overflow-y: auto">
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                  :summary-method="getSummaries" @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                  show-summary
                  :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="60">
          </el-table-column>
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="submit_time" label="订单提交时间" width="150" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div>{{scope.row.submit_time|timestampToTime}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="order_code" label="订单编号" min-width="150" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <span style="color: #1989FA;cursor: pointer" @click="gotoOrderDetail(scope.row.id)">
                {{scope.row.order_code}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="original_amount" label="订单实付金额" width="120" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div v-if="scope.row.original_amount||scope.row.original_amount==0">￥{{scope.row.original_amount}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="original_amount" label="欠票金额" width="100" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div v-if="scope.row.original_amount||scope.row.original_amount==0">￥{{scope.row.original_amount}}</div>
            </template>
          </el-table-column>
<!--          <el-table-column prop="agent_debt_money" label="欠款金额" width="100" :show-overflow-tooltip='true'>-->
<!--            <template slot-scope="scope">-->
<!--              <div v-if="scope.row.agent_debt_money||scope.row.agent_debt_money==0">￥{{scope.row.agent_debt_money}}</div>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column prop="seller_name" label="商家名称" width="190" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="mobile" label="订单总金额" width="100" :show-overflow-tooltip='true'>
            <template slot-scope="scope">
              <div>￥{{scope.row.total_amount}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="order_status" label="订单状态" width="100">
            <template slot-scope="scope">
              <div plain v-if="scope.row.order_status==100">已取消</div>
              <div plain style="color: #F56C6C" v-if="scope.row.order_status==101">待付款</div>
              <div plain style="color: #409EFF" v-if="scope.row.order_status==102">已付款</div>
              <div plain style="color: #FF00FF" v-if="scope.row.order_status==103">已确认</div>
              <div plain style="color: #E6A23C" v-if="scope.row.order_status==104">已出库</div>
              <div plain style="color: #909399" v-if="scope.row.order_status==105">待收货</div>
              <div plain style="color: #67C23A" v-if="scope.row.order_status==106">已完成</div>
            </template>
          </el-table-column>
          <el-table-column prop="send_status" label="发货状态" width="100">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" plain
                         @click="gotoInvoice(scope.row.send_id, scope.row.id,scope.row.submit_time,scope.row.order_code, 1)"
                         v-if="scope.row.send_status=='0'&&scope.row.order_status>101">
                待发货
              </el-button>
              <el-button type="success" size="mini" plain
                         @click="gotoInvoice(scope.row.send_id, scope.row.id, scope.row.submit_time,scope.row.order_code, 1)"
                         v-if="scope.row.send_status=='1'&&scope.row.order_status>101">
                已发货
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="pay_type" label="支付类型" width="120">
            <template slot-scope="scope">
              <div plain v-if="scope.row.pay_type==211">在线支付</div>
<!--              <div plain v-else-if="scope.row.pay_type==212">线下支付</div>-->
              <div plain v-else-if="scope.row.pay_type==215">挂账</div>
              <div plain v-else></div>
            </template>
          </el-table-column>
          <el-table-column prop="pay_status" label="结算状态" width="120">
            <template slot-scope="scope">
              <div plain v-if="scope.row.pay_status==1">已结算</div>
              <div plain v-else>未结算</div>
            </template>
          </el-table-column>
          <el-table-column align="left" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="sendGood(scope.row.send_id,scope.row.id,scope.row.submit_time,scope.row.order_code)"
                         style="width: 80px"
                         v-if="scope.row.order_status>101&&scope.row.out_status&&scope.row.need_deliver == true">
                发货
              </el-button>
              <el-button type="success" size="mini"
                         @click="proxyDetail(scope.row.id)"
                         v-if="scope.row.has_agent_order == true"
                         style="width: 80px">代发详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-tab-pane>

      <!--给我供货-->
      <el-tab-pane label="给我供货" name="second" v-if="agent_type == '2891'">
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline1" class="user-search">
          <el-form-item label="">
            <el-date-picker
              v-model="formInline1.Date"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-input size="small" v-model="formInline1.orderCode" placeholder="输入订单编号" clearable></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input size="small" v-model="formInline1.seller_name" placeholder="输入供应商名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formInline1.orderStatus" placeholder="请选择订单状态" clearable>
              <el-option label="已取消" value="100"></el-option>
              <el-option label="待付款" value="101"></el-option>
              <el-option label="已付款" value="102"></el-option>
              <el-option label="已出库" value="104"></el-option>
              <el-option label="待收货" value="105"></el-option>
              <el-option label="已完成" value="106"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formInline1.sendStatus" placeholder="请选择发货状态" clearable>
              <el-option label="待发货" value="0"></el-option>
              <el-option label="已发货" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formInline1.pay_status" placeholder="请选择结算状态" clearable>
              <el-option label="已结算" value="1"></el-option>
              <el-option label="未结算" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formInline1.pay_type" placeholder="请选择支付类型" clearable>
              <el-option label="在线支付" value="211"></el-option>
<!--              <el-option label="线下支付" value="212"></el-option>-->
              <el-option label="挂账" value="215"></el-option>
            </el-select>
          </el-form-item>
<!--          <el-form-item label="">-->
<!--            <el-select v-model="formInline1.isAgentDebtMoney" placeholder="请选择是否有欠款金额" clearable>-->
<!--              <el-option label="是" value="1"></el-option>-->
<!--              <el-option label="否" value="0"></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
          <el-form-item label="订单实付金额价格区间">
            <el-input size="small" v-model="formInline1.minAmount" placeholder="" maxLength="7" clearable
                      style="width: 90px"></el-input>
            <span>-</span>
            <el-input size="small" v-model="formInline1.maxAmount" placeholder="" maxLength="7" clearable
                      style="width: 90px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="search1">查询</el-button>
            <el-button size="small" type="warning" @click="exportExcel1">导出</el-button>
          </el-form-item>
        </el-form>
        <!--给我供货-列表-->
        <div style="height: 550px;overflow-y: auto">
          <el-table size="small" :data="listData1" highlight-current-row v-loading="loading" border
                    :summary-method="getSummaries" @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                    show-summary
                    :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                    element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column
              label="序号"
              width="60">
              <template slot-scope="scope">
                {{pageparm1.pageSize * (pageparm1.currentPage - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="submit_time" label="订单提交时间" width="150" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <div>{{scope.row.submit_time|timestampToTime}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="order_code" label="订单编号" width="150" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
              <span style="color: #1989FA;cursor: pointer" @click="gotoOrderDetail(scope.row.id)">
                {{scope.row.order_code}}
              </span>
              </template>
            </el-table-column>
            <el-table-column prop="original_amount" label="订单实付金额" width="120" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <div v-if="scope.row.original_amount||scope.row.original_amount==0">￥{{scope.row.original_amount}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="original_amount" label="欠票金额" width="120" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <div v-if="scope.row.original_amount||scope.row.original_amount==0">￥{{scope.row.original_amount}}</div>
              </template>
            </el-table-column>
<!--            <el-table-column prop="agent_debt_money" label="欠款金额" width="100" :show-overflow-tooltip='true'>-->
<!--              <template slot-scope="scope">-->
<!--                <div v-if="scope.row.agent_debt_money||scope.row.agent_debt_money==0">￥{{scope.row.agent_debt_money}}</div>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="seller_name" label="供应商名称" min-width="180" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="mobile" label="订单总金额" width="120" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <div>￥{{scope.row.total_amount}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="order_status" label="订单状态" width="120">
              <template slot-scope="scope">
                <div plain v-if="scope.row.order_status==100">已取消</div>
                <div plain style="color: #F56C6C" v-if="scope.row.order_status==101">待付款</div>
                <div plain style="color: #409EFF" v-if="scope.row.order_status==102">已付款</div>
                <div plain style="color: #FF00FF" v-if="scope.row.order_status==103">已确认</div>
                <div plain style="color: #E6A23C" v-if="scope.row.order_status==104">已出库</div>
                <div plain style="color: #909399" v-if="scope.row.order_status==105">待收货</div>
                <div plain style="color: #67C23A" v-if="scope.row.order_status==106">已完成</div>
              </template>
            </el-table-column>
            <el-table-column prop="send_status" label="发货状态" width="100">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" plain
                           @click="gotoInvoice(scope.row.send_id, scope.row.id, scope.row.submit_time,scope.row.order_code, 2)"
                           v-if="scope.row.send_status=='0'&&scope.row.order_status>101">
                           待发货
                </el-button>
                <el-button type="success" size="mini" plain
                           @click="gotoInvoice(scope.row.send_id, scope.row.id, scope.row.submit_time,scope.row.order_code, 2)"
                           v-if="scope.row.send_status=='1'&&scope.row.order_status>101">
                  已发货
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="pay_type" label="支付类型" width="120">
              <template slot-scope="scope">
                <div plain v-if="scope.row.pay_type==211">在线支付</div>
<!--                <div plain v-else-if="scope.row.pay_type==212">线下支付</div>-->
                <div plain v-else-if="scope.row.pay_type==215">挂账</div>
                <div plain v-else></div>
              </template>
            </el-table-column>
            <el-table-column prop="pay_status" label="结算状态" width="120">
              <template slot-scope="scope">
                <div plain v-if="scope.row.pay_status==1">已结算</div>
                <div plain v-else>未结算</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
      </el-tab-pane>
    </el-tabs>
    <!-- 发货界面 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="closeDialog"
               :visible.sync="sendGoodVisible" width="55%" top="7vh" @click="sendGoodVisible = false" center :modal="false" class="backRgba">
      <p class="title f20 color333 fontWeight mb20">发货信息</p>
      <div class="flex_box mb10">
        <div class="order_no item f15">
          <p class="color333 inline mr12">订单编号</p>
          <span class="color666">{{detailData.order_code}}</span>
        </div>
      </div>
      <div class="flex_box mb10">
        <div class="order_no item f15">
          <p class="color333 inline mr12">配送方式</p>
          <span class="color666">{{detailData.delivery_com_name}}</span>
        </div>
      </div>
      <div class="flex_box f15 shipping_information mb10">
        <span class="color333 title mr12">收货人信息</span>
        <div class="flex_box" v-if="detailData.receive_name">
          <p class="color666 mr12">
            {{detailData.receive_name}}，{{detailData.receive_phone}}，{{detailData.receive_addr}}</p>
          <span class="copy"
                @click="copy(detailData.receive_name,detailData.receive_phone,detailData.receive_addr)"><img
            src="/static/img/copy.png" alt=""></span>
        </div>
      </div>
      <div class="mb10">
        <div class="order_no item f15">
          <p class="color333 inline mr12">订单留言</p>
          <span class="color666">{{detailData.order_msg}}</span>
        </div>
      </div>
      <!--列表-->
      <div class="table mt50">
        <div>
          <p class="title f20 color333 fontWeight mb20">待发货商品清单</p>
          <div class="mb20">
            <el-button type="danger" size="mini" @click.native.prevent="batchDeleteRow()">批量移除
            </el-button>
          </div>
        </div>
        <el-table size="small" :data="ordeSendData"
                  highlight-current-row v-loading="loading" border show-summary
                  ref="multipleTable" :summary-method="getSendSummaries" :row-key="rowKey" @selection-change="handleSelectionChange"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="60">
          </el-table-column>
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="product_code" label="商品编码" width="150" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="product_name" label="销售名称" min-width="220" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="require_send_num" label="客户下单数" width="120">
          </el-table-column>
          <el-table-column prop="sendNum" label="实际发货数" width="120">
            <template slot-scope="scope">
              <div>
                <el-input v-model="scope.row.sendNum" placeholder="发货数" clearable
                          @blur="reviseNum(scope.row.sendNum,scope.row.require_send_num,scope.row.sendEdNum)"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sendEdNum" label="已发货数" width="120">
          </el-table-column>
          <el-table-column align="center" label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click.native.prevent="deleteRow(scope.$index, ordeSendData)">移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div class="block" style="margin-top: 15px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="ordeSendData.length"
          >
          </el-pagination>
        </div>
      </div>
      <p class="title f20 color333 fontWeight mb20 mt50">填写物流信息</p>
      <el-form label-width="120px" :model="flashForm" :rules="rules" ref="flashForm" class="delivery">
        <el-form-item label="发货模式" prop="sendMode">
          <div v-if="agent_type == '2891'">
            <el-select v-model="flashForm.sendMode" placeholder="请选择发货模式" clearable @change="changeSendMode">
              <el-option label="普通模式" value="2740"></el-option>
              <el-option label="电子面单模式" value="2741"></el-option>
            </el-select>
          </div>
          <div v-else>
            <el-select v-model="flashForm.sendMode" placeholder="请选择发货模式" disabled clearable @change="changeSendMode">
              <el-option label="普通模式" value="2740"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <div v-if="flashForm.sendMode == 2741">
          <el-form-item label="快递公司" prop="sendDeliveryCompanyId">
            <el-select v-model="flashForm.sendDeliveryCompanyId" filterable placeholder="请选择快递公司"
                       @change="popularCompChange(flashForm.sendDeliveryCompanyId)">
              <el-option
                style="width: 220px;"
                v-for="item in popularcompDeliveryListData"
                :key="item.id"
                :label="item.name"
                :value="item.com_no">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递类型" prop="deliveryType">
            <el-select v-model="flashForm.deliveryType" placeholder="请选择快递类型" clearable>
              <el-option v-for="type in TypeDeliveryListData" :key="type.id" :label="type.name" :value="type.code">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="flex_box">
            <div class="flex_box" style="align-items: center;margin-left: 24%;">
              <p class="bfore f14 color666 mr12 w120 lh40"style="text-align: right;">打印机</p>
              <span class="f14 color333 w220 lh40" v-if="siid">{{ siid }}</span>
              <el-button class="ml10" type="primary" @click="addSelectBox" plain v-else>新增打印机</el-button>
            </div>
          </div>
        </div>
        <div v-else>
          <el-form-item label="快递公司" prop="sendDeliveryCompanyId">
            <el-select v-model="flashForm.sendDeliveryCompanyId" filterable placeholder="请选择快递公司" clearable
                       @change="compChange(flashForm.sendDeliveryCompanyId)">
              <el-option
                v-for="item in compDeliveryListData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递单号" prop="sendDeliveryCode">
            <el-input size="small" v-model.trim="flashForm.sendDeliveryCode" auto-complete="off" maxLength="50" clearable
                      placeholder="请输入快递单号"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">关 闭</el-button>
        <el-button size="small" type="primary" :loading="loading" :disabled="!isCanSubmit" class="title"
                   @click="submitSendForm('flashForm')">
          确认发货
        </el-button>
      </div>
    </el-dialog>

    <!-- 出库弹窗-->
    <el-dialog title="出库" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="boundDialog"
               :visible.sync="boundVisible" width="55%" top="7vh" center :modal="false" class="backRgba">
      <p class="title f20 color333 fontWeight mb20">订单信息</p>
      <div class="flex_box mb10">
        <div class="order_no item f15">
          <p class="color333 inline mr12">订单编号</p>
          <span class="color666">{{detailData.order_code}}</span>
        </div>
      </div>
      <div class="flex_box mb10">
        <div class="order_no item f15">
          <p class="color333 inline mr12">配送方式</p>
          <span class="color666">{{detailData.delivery_com_name}}</span>
        </div>
      </div>
      <div class="flex_box f15 shipping_information mb10">
        <span class="color333 title mr12">收货人信息</span>
        <div class="flex_box" v-if="detailData.receive_name">
          <p class="color666 mr12">
            {{detailData.receive_name}}，{{detailData.receive_phone}}，{{detailData.receive_addr}}</p>
          <span class="copy"
                @click="copy(detailData.receive_name,detailData.receive_phone,detailData.receive_addr)"><img
            src="/static/img/copy.png" alt=""></span>
        </div>
      </div>
      <div class="mb10">
        <div class="order_no item f15">
          <p class="color333 inline mr12">订单留言</p>
          <span class="color666">{{detailData.order_msg}}</span>
        </div>
      </div>
      <!--列表-->
      <div class="table" style="max-height: 400px;overflow-y: auto;margin-top: 20px">
        <el-table size="small" :data="boundData" highlight-current-row v-loading="loading" border
                  @selection-change="handleSelectionChange" row-key="id" :expand-row-keys="expandRowKeys"
                  :header-cell-style="{background:'#F5F7FA',color:'#666666'}" @expand-change="handleExpandChange"
                  element-loading-text="拼命加载中" style="width: 100%;">
<!--          :row-class-name="rowClassName"-->
          <!--子列表-->
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="tabdren">
<!--                v-if="scope.row.childrenData && scope.row.childrenData.length > 0"-->
                <el-table :data="scope.row.childrenData" style="width: 100%">
                  <el-table-column label="" width="48">
                  </el-table-column>
                  <el-table-column label="出库数" prop="sendNum" width="100" :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.sendNum" :disabled="!scope.row.isShow" size="small" placeholder="出库数"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="批次号" prop="batchNo" min-width="180" :show-overflow-tooltip='true'>
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.batchNo" :disabled="!scope.row.isShow" size="small" placeholder="批次号"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="productionDate" label="生产日期" width="150">
                    <template slot-scope="scope" style="position: relative">
                      <div class="block">
                        <el-date-picker :disabled="!scope.row.isShow" style="width: 139px;"
                                        v-model="scope.row.productionDate"
                                        type="date"
                                        placeholder="生产日期">
                        </el-date-picker>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="expiryDate" label="有效期" width="150">
                    <template slot-scope="scope" style="position: relative">
                      <div class="block">
                        <el-date-picker :disabled="!scope.row.isShow" style="width: 139px;"
                                        v-model="scope.row.expiryDate"
                                        type="date"
                                        placeholder="有效期">
                        </el-date-picker>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="300">
                    <template slot-scope="scope">
                      <el-button type="primary" plain size="mini"
                                 @click.native.prevent="saveDetail(scope.$index,scope.row)" v-if="scope.row.isShow"
                                 style="width: 80px">保存
                      </el-button>
                      <el-button type="primary" plain size="mini"
                                 @click.native.prevent="editDetail(scope.$index,scope.row)" v-if="!scope.row.isShow"
                                 style="width: 80px">编辑
                      </el-button>
                      <el-button type="danger" plain size="mini"
                                 @click.native.prevent="boundDelete(scope.$index,scope.row)"
                                 style="width: 80px">删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="product_code" label="商品编码" width="150" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="product_name" label="销售名称" min-width="180" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="require_send_num" label="客户下单数" width="100" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="sendEdNum" label="已出库数" width="100" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column align="center" label="操作" width="300">
            <template slot-scope="scope">
              <el-button type="success" plain size="mini" @click="addChildren(scope.$index, scope.row)"
                         style="width: 80px">新增子项
              </el-button>
              <el-button type="danger" plain size="mini"
                         @click.native.prevent="boundDelete(scope.$index,scope.row)"
                         style="width: 80px">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="boundDialog">关 闭</el-button>
        <el-button size="small" type="primary" :loading="loading" :disabled="!isCanSubmit" class="title"
                   @click="printSendForm()">
          预览出库单
        </el-button>
      </div>
    </el-dialog>

    <!--打印出库单弹窗-->
    <el-dialog title="预览出库单" :close-on-click-modal="false" :close-on-press-escape="false" ref="printDialog"
               :visible.sync="printGoodVisible" width="55%" top="5vh" @click="printGoodVisible = false" center :modal="false" class="backRgba">
      <div class="official">
        <div class="sealimg">
          <img src="/static/img/icon-seal.png" alt="">
        </div>
      </div>
      <p class="title f25 color333 fontWeight textCenter bb1">
        松佰商城(湖南展博科技发展有限公司)
      </p>
      <div class="flex_box h35 bb1 color333 fontWeight" style="align-items: flex-end;">
        <div class="order_no item f15">
          <p class="inline">地址：</p>
          <span class="mr20">{{ previewDite.address }}</span>
          <p class="inline">网址：</p>
          <span>{{ previewDite.website }}</span>
        </div>
      </div>
      <div class="flex_box h35 bb1 color333 f15" style="justify-content: space-between;align-items: flex-end;">
        <div class="order_no item">
          <p class="inline">电话：</p>
          <span>{{ previewDite.phone }}</span>
        </div>
        <div class="order_no item">
          <p class="inline">传真：</p>
          <span>{{ previewDite.fax }}</span>
        </div>
      </div>
      <p class="title f25 color333 fontWeight textCenter bb1">
        出库单(代销售合同)
      </p>
      <div class="flex_box h35 bb1 color333 f15" style="align-items: flex-end;">
        <div class="order_no item width50">
          <p class="inline">订单号：</p>
          <span class="mr20">{{ previewDite.orderCode }}</span>
          <p class="inline">结算方式：</p>
          <span class="mr20">{{ previewDite.payName }}</span>
        </div>
        <div class="divider"></div>
        <div class="order_no item ">
          <p class="inline">收件人：</p>
          <span>{{ previewDite.receiveName }}</span>
        </div>
      </div>
      <div class="flex_box h35 bb1 color333" style="justify-content: space-between;align-items: flex-end;">
        <div class="order_no item f15">
          <p class="inline">收货单位：</p>
          <span>{{ previewDite.receiveCompany }}</span>
        </div>
      </div>
      <div class="flex_box h35 bb1 color333 f15" style="align-items: flex-end;">
        <div class="order_no item width50">
          <p class="inline">收货地址：</p>
          <span class="mr20">{{ previewDite.receiveAddress }}</span>
        </div>
        <div class="divider"></div>
        <div class="order_no item">
          <p class="inline">制单日期：</p>
          <span>{{ previewDite.date }}</span>
        </div>
      </div>
      <div class="flex_box h70 bb1 color333" style="align-items: flex-end;">
        <div class="order_no item f15 width50">
          <p class="inline">发票：</p>
          <span class="color666 mr20">{{ previewDite.invoiceType }}</span>
          <p class="inline">产品三证：</p>
          <span class="mr20">{{ previewDite.needProductCert }}</span>
          <p class="inline">公司资质：</p>
          <span>{{ previewDite.needCert }}</span>
        </div>
        <div class="divider2"></div>
      </div>
      <div class="flex_box h35 bb1 color333 fontWeight" style="align-items: flex-end;">
        <div class="order_no item f15">
          <p class="inline">客户留言：</p>
          <span>{{previewDite.orderMsg}}</span>
        </div>
      </div>
      <div class="flex_box h35 color333 fontWeight" style="align-items: flex-end;">
        <div class="order_no item f15">
          <p class="inline">客服备注：</p>
          <span>{{ previewDite.auditRemark }}</span>
        </div>
      </div>
       <!--列表-->
      <div class="table tabblock">
        <el-table size="small" :data="printSendData"
                  highlight-current-row v-loading="loading" border show-summary
                  ref="multipleTable" :summary-method="getPrintSummaries" :row-key="printRowKey"
                  element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column
            label="编号"
            align="center"
            type="index"
            width="50">
          </el-table-column>
          <el-table-column prop="product_code" label="编码" width="80" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="product_name" label="品名及规格/生产厂商/储运条件" min-width="200" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="pack_unit" label="单位" width="80" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="reg_cert" label="注册证号" width="80" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="average_price" label="单价" width="80" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="batchNo" label="批号" width="80" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="productionDate" label="生产日期" width="90" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="expiryDate" label="有效期" width="90" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="saled_num" label="数量" width="80" :show-overflow-tooltip='true'>
          </el-table-column>
          <el-table-column prop="totalPriceStr" label="金额" width="80" :show-overflow-tooltip='true'>
          </el-table-column>
        </el-table>
      </div>
      <div class="terms">
        声明条款：1.收到货物如有疑问，请通过www.202832.com联系客服或拨打客服热线4008-202832。
        <div class="bb1"></div>
        <div style="margin-left: 85px">2.请保存好此单，作为退换维修货物的凭证，无此单恕不受理，谢谢合作!</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" :loading="loading" @click="printingForm()">
          确认打印
        </el-button>
        <el-button size="small" @click="printExportExcel">导出</el-button>
        <el-button size="small" @click="printGoodVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  orderList,
  orderExcel,
  orderDetail,
  orderSend,
  popularDeliveryList,
  addSend,
  expressType,
  printInfo,
  eorderDeliveryList,
  settleOrder,
  outListExport, outListPreview, outListAliyunPrint
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate, uploadFile} from '../../utils/util'
  import {getToken, upload, uploadImgTmp, uploadPdf} from "../../api/commonMG";

  export default {
    data: () => {
      return {
        orderId: '',
        order_code: '',
        sendId: '',
        loading: false, //是显示加载
        sendGoodVisible: false, //控制页面显示与隐藏
        boundVisible: false, // 出库弹窗显示与隐藏
        printGoodVisible: false,
        activeName: 'first',
        expandRowKeys: [],
        title: '发货单',
        flashForm: {
          sendDeliveryCode: '',
          deliveryType: '',
          sendDeliveryCompanyId: '',
          sendMode: '',
          deliveryCount: '',
        },
        com_no: "",
        // rules表单验证
        rules: {
          // sendDeliveryCode: [{required: true, message: '请输入快递单号', trigger: 'change'}],
          sendMode: [{required: true, message: '请选择发货模式', trigger: 'change'}],
          sendDeliveryCompanyId: [{required: true, message: '请选择快递公司', trigger: 'change'}],
          deliveryCount: [{required: true, message: '请输入子母件数量', trigger: 'change'}],
          deliveryType: [{required: true, message: '请选择快递类型', trigger: 'change'}],
        },
        formInline: {
          page: 1,
          rows: 10,
          Date: '',
          startDate: '',
          endDate: '',
          orderCode: '',
          contactPhone: '',
          orderStatus: '',
          sendStatus: '',
          minAmount: '',
          maxAmount: '',
          custName: '',
          receiverName: '',
          needInvoice: '',
          hasInvoiceBalance: '',
          product_code: '',
          seller_name: '',
          hasPayReceipt:'',
          pay_status: '',
          pay_name: '',
          pay_id: '',
          isAgentDebtMoney: '',
          isAgent: true
        },
        formInline1: {
          page: 1,
          rows: 10,
          Date: '',
          startDate: '',
          endDate: '',
          orderCode: '',
          contactPhone: '',
          orderStatus: '',
          sendStatus: '',
          minAmount: '',
          maxAmount: '',
          custName: '',
          receiverName: '',
          needInvoice: '',
          hasInvoiceBalance: '',
          product_code: '',
          seller_name: '',
          hasPayReceipt:'',
          pay_status: '',
          pay_id: '',
          isAgentDebtMoney: '',
          isAgent: true,
          isToMe: true
        },
        listData: [], //用户数据
        listData1: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        pageparm1: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页的数据条数
        value: '',
        ordeSendData: [],
        compDeliveryListData: [],
        popularcompDeliveryListData: [],
        TypeDeliveryListData: [],
        detailData: {},
        previewDite: {},
        isCanSubmit: true,
        checkSubmit: true,
        selectTableData: [],
        printSendData: [],
        isShowEditPaid: true,
        comnoid: '',
        siid: '',
        submit_time: '',
        agent_type: localStorage.getItem('agent_type')||'2890',
        isSupplier: 1,
        boundData: [],
        childrenObj: {
          id: '',
          sendNum: '',
          batchNo: '',
          productionDate: '',
          expiryDate: '',
          isShow: true
        },
        productionDate: '',
        expiryDate: '',
        docId: '',
        expandedRowId: '',
        childrenData: [],
        outProducts: []
      }
    },
    // 注册组件
    components: {
      Pagination
    },

    /**
     * 创建完毕
     */
    created() {
      if (this.$route.query.sendStatus) {
        this.formInline.sendStatus = this.$route.query.sendStatus
        this.getdata(this.formInline)
      } else {
        this.getdata(this.formInline)
      }
    },
    mounted() {
      // let seller_name = localStorage.getItem('seller_name')
      // console.log(seller_name)
      // if (seller_name.indexOf('辽宁中联医药有限公司') > -1) {
      //   this.isShowEditPaid = true;
      // } else {
      //   this.isShowEditPaid = false;
      // }
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      rowKey () {
        return
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        orderList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.totalSize
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 获取公司列表 1-1
      getdata1(parameter) {
        this.loading = true
        orderList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData1 = res.content
              // 分页赋值
              this.pageparm1.currentPage = this.formInline1.page
              this.pageparm1.pageSize = this.formInline1.rows
              this.pageparm1.total = res.totalSize
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather1(parm) {
        this.formInline1.page = parm.currentPage
        this.formInline1.rows = parm.pageSize
        this.getdata1(this.formInline1)
      },
      // 搜索事件
      search() {
        if (this.formInline.Date) {
          this.formInline.startDate = timestampToDate(this.formInline.Date[0])
          this.formInline.endDate = timestampToDate(this.formInline.Date[1])
        } else {
          this.formInline.startDate = ''
          this.formInline.endDate = ''
        }
        this.formInline.page = 1;
        if (this.formInline.minAmount && !(/(^[1-9]\d*$)/.test(this.formInline.minAmount))) {
          this.$message.error('价格区间请输入正整数!');
          return
        }
        if (this.formInline.maxAmount && !(/(^[1-9]\d*$)/.test(this.formInline.maxAmount))) {
          this.$message.error('价格区间请输入正整数!');
          return
        }
        if (Number(this.formInline.minAmount) > Number(this.formInline.maxAmount)) {
          this.$message.error('价格区间错误,请从小到大填写!');
          return
        }
        this.getdata(this.formInline)
      },
      // 搜索事件
      search1() {
        if (this.formInline1.Date) {
          this.formInline1.startDate = timestampToDate(this.formInline1.Date[0])
          this.formInline1.endDate = timestampToDate(this.formInline1.Date[1])
        } else {
          this.formInline1.startDate = ''
          this.formInline1.endDate = ''
        }
        this.formInline1.page = 1;
        if (this.formInline1.minAmount && !(/(^[1-9]\d*$)/.test(this.formInline1.minAmount))) {
          this.$message.error('价格区间请输入正整数!');
          return
        }
        if (this.formInline1.maxAmount && !(/(^[1-9]\d*$)/.test(this.formInline1.maxAmount))) {
          this.$message.error('价格区间请输入正整数!');
          return
        }
        if (Number(this.formInline1.minAmount) > Number(this.formInline1.maxAmount)) {
          this.$message.error('价格区间错误,请从小到大填写!');
          return
        }
        this.getdata1(this.formInline1)
      },
      //发货单
      sendGood: function (send_id, id, time, code) {
        this.sendId = send_id;
        this.orderId = id;
        this.submit_time = time;
        this.order_code = code;
        this.flashForm = {
          deliveryCount: 1,
          sendMode: "2740",
          sendDeliveryCode: '',
          deliveryType: '',
          sendDeliveryCompanyId: '',
        };
        this.sendGoodVisible = true;
        this.currentPage = 1;
        orderDetail(id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.detailData = res.content || '';
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        orderSend(send_id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.ordeSendData = res.content
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        let data = {
          page: 0,
          rows: 10,
          name: ""
        }
        popularDeliveryList(data)
          .then(res => {
            if (res.success) {
              this.compDeliveryListData = res.content;
            }
          })
          .catch(err => {
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 发货单-电子面单模式-快递公司
      compChange(sendDeliveryCompanyId,deliveryType) {
        for(let i in this.compDeliveryListData) {
          if(this.compDeliveryListData[i].id == sendDeliveryCompanyId) {
            this.comnoid = this.compDeliveryListData[i].id
          }
        }
        this.$set(this.flashForm, "deliveryType", "");
        expressType(sendDeliveryCompanyId)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.TypeDeliveryListData = res.content;
                this.flashForm.deliveryType = deliveryType;
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      popularCompChange(sendDeliveryCompanyId,deliveryType) {
        for(let i in this.popularcompDeliveryListData) {
          if(this.popularcompDeliveryListData[i].com_no == sendDeliveryCompanyId) {
            this.comnoid = this.popularcompDeliveryListData[i].id
          }
        }
        this.$set(this.flashForm, "deliveryType", "");
        expressType(sendDeliveryCompanyId)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.TypeDeliveryListData = res.content;
                this.flashForm.deliveryType = deliveryType;
                this.flashForm.deliveryType = res.content[0].code;
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 关闭编辑、增加弹出框
      closeDialog() {
        this.sendGoodVisible = false;
        this.$refs["flashForm"].resetFields();
      },
      // 出库弹窗关闭
      boundDialog() {
        this.boundVisible = false;
        this.boundData = []
      },
      gotoInvoice(id, send_id, time, code, show) {
        localStorage.setItem('path', '/supply/supplyInvoiceOrder')
        let tag = {
          url: "/supply/supplyInvoiceOrder",
          menuname: "供货发货单"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/supply/supplyInvoiceOrder', query: {send_id: send_id, id: id, time: time, code: code, show: show}})
      },
      // 跳转订单详情
      gotoOrderDetail(id) {
        localStorage.setItem('path', '/order/orderDetail')
        let tag = {
          url: "/order/orderDetail",
          menuname: "订单详情"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/order/orderDetail', query: {id: id}})
      },
      // 点击复制
      copy(name, phone, addr) {
        let url = name + ',' + phone + ',' + addr;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        oInput.remove()
      },
      // 我供货的-导出
      exportExcel() {
        orderExcel(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '我供货的订单信息.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 给我供货-导出
      exportExcel1() {
        orderExcel(this.formInline1)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '给我供货的订单信息.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 结算订单
      getOrder() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        if (this.selectTableData[0].order_status == '100') {
          this.$message.error('已取消的订单不能结算!');
          return
        }
        if (this.selectTableData[0].order_status == '101') {
          this.$message.error('待付款的订单不能结算!');
          return
        }
        const title = '是否对订单进行结算？';
        this.$confirm(title, '结算订单', {
          confirmButtonText: '确定结算',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          settleOrder(this.selectTableData[0].id,this.isSupplier)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功结算订单!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 待发货商品清单-删除
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      // 待发货商品清单-批量删除
      batchDeleteRow() {
        var sendTable = this.ordeSendData;
        this.$refs.multipleTable.selection.forEach((Ele, index) => {
          for (var i = 0; i < sendTable.length; i++) {
            var id = sendTable[i].id;
            if (id == Ele.id) {
              sendTable.splice(i, 1);
            }
          }
          this.$refs.multipleTable.clearSelection();
        });
      },
      reviseNum(sendNum, require_send_num, sendEdNum) {
        if (!(/(^[1-9]\d*$)/.test(sendNum))) {
          this.$message.error('请输入正整数!');
          return
        }
        if (sendNum > require_send_num - sendEdNum) {
          this.$message.error('实际发货数不能大于可发货数!');
          return
        }
      },
      //每页条数改变时触发 选择一页显示多少行
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      //当前页改变时触发 跳转其他页
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      // 发货单-确认发货
      submitSendForm(formName) {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        this.id = this.selectTableData[0].id;
        this.isCanSubmit = true;
        let parameter = {
          orderId: this.orderId,
          sendId: this.sendId,
          sendDeliveryCompanyId: this.comnoid,
          sendDeliveryCode: this.flashForm.sendDeliveryCode,
          deliveryType: this.flashForm.deliveryType,
          sendMode: this.flashForm.sendMode,
          deliveryCount: this.flashForm.deliveryCount,
          siid: this.siid,
          sendDeliverymark: "",
          sendItems: []
        }
        this.selectTableData.forEach((data) => {
          let obj = {
            id: data.id,
            sendNum: data.sendNum,
            maxSendNum: data.require_send_num,
            send_id: this.sendId,
            product_id: data.product_id,
          }
          parameter.sendItems.push(obj)
          if (!(/(^[1-9]\d*$)/.test(data.sendNum))) {
            this.checkSubmit = false
            return
          } else {
            this.checkSubmit = true
          }
          if (data.sendNum > data.require_send_num - data.sendEdNum) {
            this.checkSubmit = false
            return
          } else {
            this.checkSubmit = true
          }
        })
        if (!parameter.sendItems.length) {
          this.$message.error('无待发货商品!');
          return
        }
        if (!this.checkSubmit) {
          this.$message.error('请输入正确的实际发货数!');
          return
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            addSend(parameter)
              .then(res => {
                this.isCanSubmit = true;
                this.loading = false
                if (res.success == false) {
                  if (res.code == '-1100') {
                    localStorage.setItem('path', '/order/invoiceOrder')
                    let tag = {
                      url: "/order/invoiceOrder",
                      menuname: "发货单"
                    }
                    this.$store.commit('selectMenu', tag)
                    this.$router.push({path: '/order/invoiceOrder', query: {id: this.sendId, time: this.submit_time, code: this.order_code}})
                    this.sendGoodVisible = false;
                    this.$refs["flashForm"].resetFields();
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                } else {
                  this.$message({
                    type: 'success',
                    message: '发货成功'
                  })
                  this.sendGoodVisible = false;
                  this.$refs["flashForm"].resetFields();
                  this.getdata(this.formInline)
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.loading = false;
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      addSelectBox() {
        localStorage.setItem('path', '/store/storePrinter')
        let tag = {
          url: "/store/storePrinter",
          menuname: "绑定打印机"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/store/storePrinter'})
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      // 发货模式
      changeSendMode() {
        if (this.flashForm.sendMode == '2741') {
          // 电子面单快递公司
          let populardata = {
            page: 0,
            rows: 10,
            name: ""
          }
          eorderDeliveryList(populardata)
            .then(res => {
              if (res.success) {
                this.popularcompDeliveryListData = res.content;
              }
            })
            .catch(err => {
              this.$message.error('网络错误，请稍后再试！')
            })
          // 打印机信息
          printInfo()
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                if(res.content) {
                  this.siid = res.content;
                }
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
        this.flashForm = {
          sendMode: this.flashForm.sendMode,
          deliveryCount: this.flashForm.deliveryCount,
          sendDeliveryCode: '',
          sendDeliveryCompanyId: '',
          deliveryType: '',
        }
        this.$nextTick(() => {
          this.$refs["flashForm"].clearValidate(['sendDeliveryCode', 'deliveryType', 'sendDeliveryCompanyId', 'sendMode', 'deliveryCount']);
        });
      },
      // tab页
      handleClick(tab, event) {
        console.log(tab.index)
        if (tab.index == 0) {
          this.getdata(this.formInline)
        } else if (tab.index == 1) {
          this.getdata1(this.formInline1)
        }
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (column.label == '订单实付金额') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else if (column.label == '欠票金额') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else {
            sums[index] = '-';
          }
        });
        return sums;
      },
      getSendSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总价';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index];
          } else {
            sums[index] = '-';
          }
        });
        return sums;
      },
      getPrintSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (column.property === 'saled_num') {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
            } else {
              sums[index] = '0';
            }
          } else if (column.property === 'totalPriceStr') {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
              sums[index] = sums[index].toFixed(2);
            } else {
              sums[index] = '0.00';
            }
          } else {
            sums[index] = '-';
          }
        });
        return sums;
      },
      printRowKey(row) {
        return row.id;
      },
      // 代发详情
      proxyDetail(id) {
        localStorage.setItem('path', '/order/proxyDetails')
        let tag = {
          url: "/order/proxyDetails",
          menuname: "代发详情"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/order/proxyDetails', query: {id: id}})
      },
      // 出库
      getOutbound() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.boundVisible = true;
        this.orderId = this.selectTableData[0].id
        orderDetail(this.selectTableData[0].id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.detailData = res.content || '';
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
        orderSend(this.selectTableData[0].send_id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                res.content.forEach((item) => {
                  item.isShow = false;
                  this.boundData.push(item)
                })
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      findParentRow(childRow) {
        for (let i = 0; i < this.boundData.length; i++) {
          const parent = this.boundData[i];
          if (parent.childrenData.includes(childRow)) {
            return parent;
          }
        }
        return null;
      },
      getTotalDesc(childrenData) {
        let total = 0;
        childrenData.forEach(child => {
          total += parseInt(child.sendNum || 0);
        });
        return total;
      },
      // 保存出库数据
      saveDetail(index, row, type) {
        const parentRow = this.findParentRow(row);
        const totalDesc = this.getTotalDesc(parentRow.childrenData);
        const available = parseInt(parentRow.require_send_num) - parseInt(parentRow.sendEdNum);
        if (totalDesc > available) {
          this.$message.error('出库数大于可出库数');
          return;
        }
        if (!row.sendNum) {
          this.$message({
            type: 'info',
            message: '出库数不能为空'
          })
          return
        } else if (!(/(^-?[1-9]\d*$|^0$)/.test(row.sendNum))) {
          this.$message({
            type: 'error',
            message: '出库数需填写正整数'
          });
          return
        }
        if (!row.batchNo) {
          this.$message({
            type: 'info',
            message: '批次号不能为空'
          })
          return
        }
        if (!row.productionDate) {
          this.$message({
            type: 'info',
            message: '生产日期不能为空'
          })
          return
        }
        if (!row.expiryDate) {
          this.$message({
            type: 'info',
            message: '有效期不能为空'
          })
          return
        }
        this.$set(row, 'isShow', false)
      },
      // 编辑出库数据
      editDetail(index, row) {
        this.$set(row, 'isShow', true)
      },
      // 行类名判断
      rowClassName({ row }) {
        return row.childrenData && row.childrenData.length > 0
          ? 'has-children'
          : 'no-children';
      },
      // 新增子项
      addChildren(parentIndex, row) {
        if (!row.childrenData) {
          this.$set(row, 'childrenData', []);
        }
        const newItem = {
          id: Date.now(),
          sendNum: '',
          batchNo: '',
          productionDate: '',
          expiryDate: '',
          isShow: true
        };
        row.childrenData.push(newItem);
        this.expandRowKeys = [...new Set([...this.expandRowKeys, row.id])];
      },
      handleExpandChange(row, expandedRows) {
        this.expandRowKeys = expandedRows.map(item => item.id);
      },
      // 删除子项
      boundDelete(index, row) {
        this.delLoop(this.boundData, row.id);
      },
      // 删除递归的方法
      delLoop(arr, id) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id === id) {
            arr.splice(i, 1);
            return;
          } else if (arr[i].childrenData) {
            const found = this.delLoop(arr[i].childrenData, id);
            if (found) {
              return;
            }
          }
        }
      },
      // 预览出库单弹窗
      printSendForm() {
        const validParentData = this.boundData.filter(parent =>
          parent.childrenData && parent.childrenData.length > 0
        );
        if (validParentData.length === 0) {
          this.$message({
            type: 'error',
            message: '没有有效的出库数据（至少需要一条包含子项的记录）'
          });
          return;
        }
        for (let parent of validParentData) {
          for (let child of parent.childrenData) {
            if (child.isShow) {
              this.$message({
                type: 'error',
                message: '有数据没有保存，请先保存数据'
              });
              return;
            }
          }
        }
        this.printGoodVisible = true;
        this.printSendData = [];
        const parameter = {
          orderId: this.orderId,
          sendItems: validParentData.map(parent => ({
            id: parent.id,
            sendNum: parent.sendNum,
            maxSendNum: parent.require_send_num,
            sendId: parent.sendId,
            product_id: parent.product_id,
            sendItemDetails: parent.childrenData.map(child => ({
              sendNum: child.sendNum,
              batchNo: child.batchNo,
              productionDate: this.formatDate(child.productionDate),
              expiryDate: this.formatDate(child.expiryDate)
            }))
          }))
        };
        outListPreview(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.previewDite = {
                address: res.address,
                website: res.website,
                orderCode: res.orderCode,
                phone: res.phone,
                fax: res.fax,
                payName: res.payName,
                receiveName: res.receiveName,
                receiveCompany: res.receiveCompany,
                receiveAddress: res.receiveAddress,
                date: res.date,
                invoiceType: res.invoiceType,
                needProductCert: res.needProductCert,
                needCert: res.needCert,
                orderMsg: res.orderMsg,
                auditRemark: res.auditRemark,
              };
              this.printSendData = res.outProducts.map(item => ({
                product_code: item.product_code,
                product_name: item.product_name || item.sale_name,
                pack_unit: item.pack_unit,
                reg_cert: item.reg_cert,
                average_price: item.average_price,
                batchNo: item.batch_num,
                productionDate: this.formatDate(item.productionDate),
                expiryDate: this.formatDate(item.expiryDate),
                saled_num: item.saled_num,
                totalPriceStr: item.totalPriceStr
              }));
            }
          })
      },
      // 预览出库单-导出
      printExportExcel() {
        const validParentData = this.boundData.filter(parent =>
          parent.childrenData && parent.childrenData.length > 0
        );
        const parameter = {
          orderId: this.orderId,
          sendItems: validParentData.map(parent => ({
            id: parent.id,
            sendNum: parent.sendNum,
            maxSendNum: parent.require_send_num,
            sendId: parent.sendId,
            product_id: parent.product_id,
            sendItemDetails: parent.childrenData.map(child => ({
              sendNum: child.sendNum,
              batchNo: child.batchNo,
              productionDate: this.formatDate(child.productionDate),
              expiryDate: this.formatDate(child.expiryDate)
            }))
          }))
        };
        outListExport(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              let url = window.URL.createObjectURL(new Blob([res]))
              // 插入一个a标签，隐藏，设置href属性，触发点击方法
              let link = document.createElement('a')
              link.style.display = 'none'
              link.href = url;
              link.setAttribute('download', '打印出库单.xlsx')
              document.body.appendChild(link)
              link.click()
              //下载完成后
              document.body.removeChild(link)
              window.URL.revokeObjectURL(url)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      formatDate(date) {
        if (!date) return ''
        const d = new Date(date)
        return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`
      },
      printingForm() {
        const validParentData = this.boundData.filter(parent =>
          parent.childrenData && parent.childrenData.length > 0
        );
        const parameter = {
          orderId: this.orderId,
          sendItems: validParentData.map(parent => ({
            id: parent.id,
            sendNum: parent.sendNum,
            maxSendNum: parent.require_send_num,
            sendId: parent.sendId,
            product_id: parent.product_id,
            sendItemDetails: parent.childrenData.map(child => ({
              sendNum: child.sendNum,
              batchNo: child.batchNo,
              productionDate: this.formatDate(child.productionDate),
              expiryDate: this.formatDate(child.expiryDate)
            }))
          }))
        };
        outListAliyunPrint(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功打印出库单'
              });
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.order_code == cell.innerText || row.mobile == cell.innerText || row.seller_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  .userRole {
    width: 100%;
  }

  a {
    text-decoration: none;
  }

  .router-link-active {
    text-decoration: none;
  }

  .textCenter {
    text-align: center;
  }

  .inline {
    display: inline-block;
  }

  .w120 {
    width: 120px;
  }

  .w220 {
    width: 220px;
  }

  .lh40 {
    line-height: 40px;
  }

  .ml10 {
    margin-left: 10px;
  }

  .mr12 {
    margin-right: 12px;
  }

  .mt50 {
    margin-top: 50px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .f15 {
    font-size: 15px;
    line-height: 18px;
  }

  .f14 {
    font-size: 14px;
  }

  .f20 {
    font-size: 20px;
  }

  .f25 {
    font-size: 25px;
    line-height: 35px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .flex_box {
    display: flex;
  }

  .h35 {
    height: 35px;
  }

  .h70 {
    height: 70px;
  }

  /deep/ .delivery .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 220px;
  }

  /deep/ .delivery .el-input--small {
    height: 40px;
    line-height: 40px;
    width: 220px;
  }

  .copy {
    width: 20px;
    height: 20px;
  }

  .copy img {
    width: 20px;
    height: 20px;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }

  .billing_item {
    border-bottom: 1px solid #EBEEF5;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 375px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .relative {
    position: relative;
  }

  .absolute {
    position: absolute;
  }

  .percentage {
    left: 200px;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  /deep/ .delivery .el-form-item {
    margin-left: 25%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader {
    height: 148px;
  }

  /deep/ .list_pic_url label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

  .video-list-box {
    width: 148px;
    height: 148px;
    margin-right: 10px;
    margin-bottom: 20px;
    border-radius: 6px;
    position: relative
  }

  .img-mask {
    width: 146px;
    height: 146px;
    line-height: 148px;
    background: #000;
    opacity: 0.6;
    position: absolute;
    z-index: 99;
    text-align: center;
    border-radius: 6px;
  }

  .img-mask i {
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    margin-right: 20px;
    cursor: pointer;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .video-default-img {
    border-radius: 6px;
  }

  .note {
    margin-top: 50px;
  }

  .note span {
    margin-left: 10px;
    font-size: 12px;
    color: #D9001B;
    line-height: 20px;
    text-align: left;
  }

  /deep/ .backRgba {
    background: rgba(0, 0, 0, 0.5) !important;
  }

  .inner {
    width: 120px;
    height: 40px;
    line-height: 40px;
  }

  .bfore :before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

  /deep/ .el-table .warning-row {
    background-color: #F56C6C;
  }

  /deep/ .block .el-date-editor .el-input, .el-date-editor .el-input__inner {
    width: 180px!important;
  }

  .mr20 {
    margin-right: 20px;
  }

  .bb1 {
    border-bottom: 1px solid #e6e6e6;
  }

  .divider {
    width: 1px;
    height: 35px;
    background-color: #e6e6e6;
    margin: 0 3px;
  }

  .divider2 {
    width: 1px;
    height: 70px;
    background-color: #e6e6e6;
    margin: 0 3px;
  }

  .width50 {
    width: 50%;
  }

  .terms {
    font-size: 16px;
    line-height: 24px;
    border: 1px solid black;
    border-top: 0;
    padding: 10px 0;
  }

  .tabblock {
    margin-top: 10px;
  }
  /* 修改表格整体边框颜色 */
  /deep/ .tabblock .el-table,
  .el-table__expanded-cell {
    border-color: black;
  }

  /deep/ .tabblock .el-table--border {
    border-right: 1px solid black;
    border-bottom: 1px solid black;
  }

  /* 修改表头边框颜色 */
  /deep/ .tabblock .el-table th.el-table__cell {
    border-color: black;
  }

  /* 修改单元格边框颜色 */
  /deep/ .tabblock .el-table td.el-table__cell {
    border-color: black;
  }

  /deep/ .tabdren .el-table__header-wrapper,
  /deep/ .tabdren .el-table__body-wrapper,
  /deep/ .tabdren .el-table__footer-wrapper {
    border-color: transparent;
  }

  /deep/ .tabdren .el-table__header tr th,
  /deep/ .tabdren .el-table__body tr td {
    border-color: transparent;
  }

  /deep/ .tabdren .el-table::before {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0!important;
  }

  .official {
    position: absolute;
    top: 80px;
    right: 80px;
  }

  .official .sealimg {
    width: 130px;
    height: 130px;
  }

  .official .sealimg img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  /deep/ .el-table .no-children .el-table__expand-icon {
    display: none !important;
  }

  /deep/ .el-table .no-children > td:first-child .cell {
    display: none;
  }
</style>





// WEBPACK FOOTER //
// src/views/supply/supplyOrder.vue